import * as React from 'react';
import { ReactNode } from 'react';
import { Box, Button, Modal } from '@amzn/awsui-components-react-v3';
import { UsageAgreementForm } from 'src/components/datausageagreement/usageAgreementForm';

export interface ResourceDetailsModalProps {
  onDismiss: () => void;
  visible: boolean;
  schema: string;
  data?: object;
  readOnly?: boolean;
  header?: ReactNode;
  customButtons?: ReactNode;
}

export const ResourceDetailsModal = (props: ResourceDetailsModalProps) => {
  return (
    <>
      <Modal
        onDismiss={props.onDismiss}
        visible={props.visible}
        size={'large'}
        header={props.header ?? 'Details'}
        footer={
          <Box float='right'>
            {props.customButtons ? (
              props.customButtons
            ) : (
              <Button variant='primary' onClick={props.onDismiss}>
                Close
              </Button>
            )}
          </Box>
        }
      >
        <UsageAgreementForm
          schema={props.schema}
          formData={props.data ?? {}}
          setFormData={() => {}}
          errors={[]}
          setErrors={() => {}}
          readOnly={props.readOnly ?? true}
          omniContext={{}}
          textOnly={true}
        />
      </Modal>
    </>
  );
};
